<template>
  <div class="bg-white position-relative overflow-hidden" role="main">
    <section>
      <div class="position-relative pt-5 bg-image-color-2 pb-5 cta-buttons-image image-bg-overlay" style="background: #003539; background-position: right 80%; background-size: cover; background-repeat: no-repeat">
        <div class="container">
          <div class="row justify-content-md-center">
            <div class="col-12">
              <h2 class="heading-section-color-bg text-capitalize fw-bold" v-if="section_title">{{ section_title }}</h2>
              <div class="text-center">
                <div class="d-block d-lg-inline-block mx-2 mb-3" v-for="(link, index) in theLinks" v-bind:key="index">
                  <a :href="link.url" class="btn d-inline-block me-1 btn-csub-gold hvr-icon-forward">{{ link.title }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    root: String
  },
  data () {
    return {
      section_title: '',
      theLinks: []
    }
  },

  async created () {
    const { data: jsonData } = await axios.get(this.root + '/library/static/data/page-navigation.json?nocache' + (new Date()).getTime())
    this.section_title = jsonData.middle_links.title
    this.theLinks = jsonData.middle_links.links
  }
}
</script>

<style scoped>
  svg {
    margin-left: 10px;
  }
</style>
